export type Bonus = {
  title: string
  description: string
  value: string
  image?: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Quick Guide: Calm a Tantrum in 3 Steps',
    description:
      'The exact 3 steps to de-escalate a meltdown before it takes over your afternoon.',
    value: '$17 value',
    image:
      'https://cdn.magicpatterns.com/uploads/acjZpEDF9LHYQbbnLeWtaU/5ee29dae-51db-4a3f-8617-b19802510060.png',
  },
  {
    title: 'Editable Custom Routine Checklist',
    description: 'Build a routine that matches your actual family, not a generic template.',
    value: '$17 value',
    image:
      'https://cdn.magicpatterns.com/uploads/5geFivv4RwGJwscyMTG7aQ/05cf0bda-e8d8-4d6a-81a4-bd270d6a5bd6.png',
  },
  {
    title: 'Reward & Positive Behavior Boards',
    description: 'Turn good behavior into a game your kid wants to win.',
    value: '$12 value',
    image:
      'https://cdn.magicpatterns.com/uploads/w2QuStMqc7YxTar85K2NrR/915544b1-18cc-4235-b683-3e723f6ebcc6.png',
  },
  {
    title: 'Mini Guide: Surviving Chaotic Mornings',
    description: 'For the mornings that go sideways before 7am.',
    value: '$12 value',
    image:
      'https://cdn.magicpatterns.com/uploads/kHAtJWwuD4Dseh5RSGCKt7/e6dd7d42-acfd-4485-8056-31b6cb199747.png',
  },
  {
    title: 'Easy & Fun Recipes to Cook With Your Kids',
    description: 'Simple, healthy recipes that double as connection time.',
    value: '$15 value',
    image:
      'https://cdn.magicpatterns.com/uploads/ffEc91WUg4ju7LDup163Yh/9e84c402-b16c-4568-9362-8b4d6aa77d8b.png',
  },
  {
    title: 'Break Your Kid Free From Screen Addiction',
    description: 'A practical guide to reclaiming your kid from phones and tablets.',
    value: '$19 value',
    image: 'https://cdn.magicpatterns.com/uploads/oXVz7GvuHabiXvUtgNjasC/bonus_2.png',
  },
  {
    title: 'Magic Stories for Positive Parenting',
    description: 'Bedtime stories that teach without lecturing.',
    value: '$15 value',
    image: 'https://cdn.magicpatterns.com/uploads/qdZHEd28dc4Z98SWxoasAn/bonus_3.png',
  },
  {
    title: 'Short Stories for Raising Kids With Values',
    description:
      'Stories that build honesty, kindness and perseverance — one bedtime at a time.',
    value: '$15 value',
    image: 'https://cdn.magicpatterns.com/uploads/1XDEjQLjhiue9upZ8x2wwQ/bonus_4.png',
  },
  {
    title: 'The Power of Focus: 101 Tips for Kids With ADHD',
    description: "Build your kid's attention span, step by step.",
    value: '$19 value',
    image:
      'https://cdn.magicpatterns.com/uploads/gMGifYFdzVZDWA7tk3H7kZ/1df58b2d-444f-458e-a376-e7300e0ae6ac.png',
  },
  {
    title: "What I Wish I'd Known Before Becoming a Mom",
    description: 'The small, big truths nobody told me — that I want to give you today.',
    value: '$15 value',
    image:
      'https://cdn.magicpatterns.com/uploads/11UJbCQKvj7M75ZWBpKRuo/f33e88aa-f0e8-4217-a14f-bcc2f5ce4d7e.png',
  },
  {
    title: '10 Screen-Free Activities to Reconnect as a Family',
    description: "Simple games to reconnect without a phone in anyone's hand.",
    value: '$12 value',
    image:
      'https://cdn.magicpatterns.com/uploads/6bX1vTbT1EH5pgLjwEFMjX/dd064d07-df82-47d3-a8c7-5ffbe2c62bb9.png',
  },
  {
    title: '70 Daily Connection Ideas',
    description: 'Quick activities that strengthen your bond with your kid.',
    value: '$16 value',
    image:
      'https://cdn.magicpatterns.com/uploads/12p3GEUS5LZfkSWsfJ5p2i/252a9369-72c6-4b1a-931f-d3b897d0e667.png',
  },
]
